import { useTranslation } from 'react-i18next';
import classes from './FormUnitAndJobTitle.module.css';

interface Props {
    unitName: string,
    jobTitle: string
}

const FormUnitAndJobTitle = ({ unitName, jobTitle }: Props) => {

    const { t } = useTranslation();

    return (
        <div className={classes.container}>
            <div>
                <div className={classes.title}>
                    {t('formUnitAndJobTitle.jobTitle')}
                </div>
                <div className={classes.text}>
                    {jobTitle}
                </div>
            </div>

            <div>
                <div className={classes.title}>
                    {t('formUnitAndJobTitle.unitName')}
                </div>

                <div className={classes.text}>
                    {unitName}
                </div>
            </div>

        </div>
    )
}

export default FormUnitAndJobTitle;